import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "../VehiculeForm.css";
import api from '../../../api/config';

const StepThreeOccasion = ({ sendData, isActive, onNext, onPrevious, commonData,handleSave }) => {
    const [formData, setFormData] = useState({
        loc_0: null, // "Le véhicule est-il pris en location ?" 0: pas en location 1: en location
        // si oui
        loc_1: null, // "Type de location :" 0: courte duree 1: longue duree 2: credit bail

        // LE LOUEUR (En location ou crédit bail)
        // si longue duree ou credit bail
        loc_17: null, // "Vous êtes" 0: personne physique 1: personne morale
        // si personne physique
        loc_18: null, // "Sexe" 0:homme 1: femme
        loc_19: null, // "Nom et prénom :"
        loc_20: null, // "Nom d'usage"
        // si personne morale
        loc_3: null, // "Raison sociale de la societe de location, si différente du titualaire"
        loc_4: null, // "N° SIRET, le cas échéant :"

        // ADRESSE DU LOUEUR
        loc_12_1: null, // "Etage / Escalier / Appartement :"
        loc_13_1: null, // "Immeuble / Résidence / Bâtiment :"
        loc_14_1: null, // "N° de la voie :"
        loc_15_1: null, // "Extension (bis, ter, ..) : "
        loc_16_1: null, // "Type de voie (rue, avenue, ..) :"
        loc_17_1: null, // "Libellé de voie :"
        loc_18_1: null, // "Lieu-dit / BP / Localité :"
        loc_19_1: null, // "Code postal :"
        loc_20_1: null, // "Commune :"
        loc_21_1: null, // "Téléphone portable :"
        loc_22_1: null, //  "Adresse mail "

        // si courte duree
        loc_5: null, // "Le locataire est :" 0: personne physique 1: personne morale
        //    si physique
        loc_23: null, // "Nom et prénom :"
        loc_24: null, // "Nom d'usage"
        // si moral
        loc_7: null, // "Raison sociale"
        loc_8: null, // ""N° SIRET"

        // LE LOCATAIRE (En location ou crédit bail)
        loc_12_2: null, // "Etage / Escalier / Appartement :"
        loc_13_2: null, // "Immeuble / Résidence / Bâtiment :"
        loc_14_2: null, // "N° de la voie :"
        loc_15_2: null, // "Extension (bis, ter, ..) : "
        loc_16_2: null, // "Type de voie (rue, avenue, ..) :"
        loc_17_2: null, // "Libellé de voie :"
        loc_18_2: null, // "Lieu-dit / BP / Localité :"
        loc_19_2: null, // "Code postal :"
        loc_20_2: null, // "Commune :"
        loc_21_2: null, // "Téléphone portable :"
        loc_22_2: null, //  "Adresse mail "
    });

    useEffect(() => {
        if (commonData) {
            if (commonData.stepThreeData && Object.keys(commonData.stepThreeData).length > 0) {
                setFormData(prevState => ({
                    ...prevState,
                    ...commonData.stepThreeData
                }));
            } else {
                const { numero_dossier, statut, vendeur_id } = commonData;
                setFormData(prevState => ({
                    ...prevState,
                    numero_dossier,
                    statut,
                    vendeur_id
                }));
            }
        }
    }, [commonData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        const numericOnlyFields = ['loc_4', 'loc_8', 'loc_14_1', 'loc_19_1', 'loc_21_1', 
                                   'loc_14_2', 'loc_19_2', 'loc_21_2'];
        
        const caseSensitiveFields = ['loc_22_1', 'loc_22_2']; // email fields
        
        if (numericOnlyFields.includes(name)) {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData({
                ...formData,
                [name]: numericValue
            });
            return;
        }
        
        if (caseSensitiveFields.includes(name)) {
            setFormData({
                ...formData,
                [name]: value
            });
            return;
        }
        
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleRadioChange = (name, value) => {
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData(formData);
        if (onNext) onNext();
    };

    const handlePrevious = () => {
        sendData(formData);
        if (onPrevious) onPrevious();
    };

    // Appel API sirene
    const [modalData, setModalData] = useState(null);
    const [modalError, setModalError] = useState(null);

    const handleSireneLookup = async (siret) => {
        const cleaned = (siret || "").replace(/\D/g, "");
        if (cleaned.length !== 14) {
            setModalError("Le numéro SIRET doit contenir 14 chiffres.");
            setModalData(null);
            return;
        }

        try {
            const response = await api.get(`/insee/verify/${cleaned}`);
            const etab = response.data.etablissement;
            setModalData(response.data);
            setModalError(null);

            // Si on est dans le bloc loueur
            if (formData.loc_4 === cleaned) {
                setFormData((prev) => ({
                    ...prev,
                    loc_3: etab?.uniteLegale?.denominationUniteLegale || prev.loc_3,
                    loc_14_1: etab?.adresseEtablissement?.numeroVoieEtablissement || prev.loc_14_1,
                    loc_16_1: etab?.adresseEtablissement?.typeVoieEtablissement || prev.loc_16_1,
                    loc_17_1: etab?.adresseEtablissement?.libelleVoieEtablissement || prev.loc_17_1,
                    loc_19_1: etab?.adresseEtablissement?.codePostalEtablissement || prev.loc_19_1,
                    loc_20_1: etab?.adresseEtablissement?.libelleCommuneEtablissement || prev.loc_20_1,
                }));
            }

            // Si on est dans le bloc du locataire
            if (formData.loc_8 === cleaned) {
                setFormData((prev) => ({
                    ...prev,
                    loc_7: etab?.uniteLegale?.denominationUniteLegale || prev.loc_7,
                    loc_14_2: etab?.adresseEtablissement?.numeroVoieEtablissement || prev.loc_14_2,
                    loc_16_2: etab?.adresseEtablissement?.typeVoieEtablissement || prev.loc_16_2,
                    loc_17_2: etab?.adresseEtablissement?.libelleVoieEtablissement || prev.loc_17_2,
                    loc_19_2: etab?.adresseEtablissement?.codePostalEtablissement || prev.loc_19_2,
                    loc_20_2: etab?.adresseEtablissement?.libelleCommuneEtablissement || prev.loc_20_2,
                }));
            }
        } catch (err) {
            setModalError(err.response?.data?.message || err.message || "Erreur inconnue");
            setModalData(null);
        }
    };



    if (!isActive) return null;

    return (
        <>
            <div className="section">
                <h3>VÉHICULE EN LOCATION</h3>

                <div className="radio-group">
                    <label>LE VÉHICULE EST-IL PRIS EN LOCATION?</label>
                    <div className='radio-group-child'>
                        <div>
                            <input
                                type="radio"
                                id="loc_0_oui"
                                name="loc_0"
                                value="1"
                                checked={formData.loc_0 === '1'}
                                onChange={() => handleRadioChange('loc_0', '1', '2')}
                                required
                            />
                            <label htmlFor="loc_0_oui">OUI</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                id="loc_0_non"
                                name="loc_0"
                                value="0"
                                checked={formData.loc_0 === '0'}
                                onChange={() => handleRadioChange('loc_0', '0')}
                                required
                            />
                            <label htmlFor="loc_0_non">NON</label>
                        </div>
                    </div>
                </div>

                {formData.loc_0 === '1' && (
                    <div className="radio-group">
                        <label>TYPE DE LOCATION:</label>
                        <div className='radio-group-child'>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_1_courte"
                                    name="loc_1"
                                    value="0"
                                    checked={formData.loc_1 === '0'}
                                    onChange={() => handleRadioChange('loc_1', '0')}
                                    required
                                />
                                <label htmlFor="loc_1_courte">COURTE DURÉE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_1_credit"
                                    name="loc_1"
                                    value="1"
                                    checked={formData.loc_1 === '1'}
                                    onChange={() => handleRadioChange('loc_1', '1')}
                                    required
                                />
                                <label htmlFor="loc_1_longue">LONGUE DURÉE </label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_1_credit"
                                    name="loc_1"
                                    value="1"
                                    checked={formData.loc_1 === '2'}
                                    onChange={() => handleRadioChange('loc_1', '2')}
                                    required
                                />
                                <label htmlFor="loc_1_credit">CRÉDIT-BAIL</label>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {formData.loc_0 === '1' && (
                <div className="section">
                    <h3>LE LOUEUR</h3>
                    <div className="radio-group">
                        <label>VOUS ÊTES:</label>
                        <div className='radio-group-child'>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_17_physique"
                                    name="loc_17"
                                    value="0"
                                    checked={formData.loc_17 === '0'}
                                    onChange={() => handleRadioChange('loc_17', '0')}
                                    required
                                />
                                <label htmlFor="loc_17_physique">PERSONNE PHYSIQUE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_17_morale"
                                    name="loc_17"
                                    value="1"
                                    checked={formData.loc_17 === '1'}
                                    onChange={() => handleRadioChange('loc_17', '1')}
                                />
                                <label htmlFor="loc_17_morale">PERSONNE MORALE</label>
                            </div>
                        </div>
                    </div>

                    {formData.loc_17 === '0' && (
                        <>
                            <div className="radio-group">
                                <label>SEXE:</label>
                                <div className='radio-group-child'>
                                    <div>
                                        <input
                                            type="radio"
                                            id="loc_18_masculin"
                                            name="loc_18"
                                            value="0"
                                            checked={formData.loc_18 === '0'}
                                            onChange={() => handleRadioChange('loc_18', '0')}
                                            required
                                        />
                                        <label htmlFor="loc_18_masculin">MASCULIN</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            id="loc_18_feminin"
                                            name="loc_18"
                                            value="1"
                                            checked={formData.loc_18 === '1'}
                                            onChange={() => handleRadioChange('loc_18', '1')}
                                        />
                                        <label htmlFor="loc_18_feminin">FÉMININ</label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="loc_19">NOM ET PRÉNOM:</label>
                                <input
                                    type="text"
                                    id="loc_19"
                                    name="loc_19"
                                    value={formData.loc_19 || ''}
                                    onChange={handleInputChange}
                                    pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                    title="Veuillez entrer un nom et prénom valides (lettres, espaces, tirets et apostrophes uniquement)"
                                    maxLength="100"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="loc_20">NOM D&apos;USAGE (FACULTATIF):</label>
                                <input
                                    type="text"
                                    id="loc_20"
                                    name="loc_20"
                                    value={formData.loc_20 || ''}
                                    onChange={handleInputChange}
                                    pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                    title="Veuillez entrer un nom valide (lettres, espaces, tirets et apostrophes uniquement)"
                                    maxLength="100"
                                />
                            </div>
                        </>
                    )}

                    {formData.loc_17 === '1' && (
                        <>
                            <div className="form-group">
                                <label htmlFor="loc_3">RAISON SOCIALE:</label>
                                <input
                                    type="text"
                                    id="loc_3"
                                    name="loc_3"
                                    value={formData.loc_3 || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="form-group siret-group">
                                <div className='input-group'>
                                    <label htmlFor="loc_4">N° SIRET:</label>
                                    <input
                                        type="text"
                                        id="loc_4"
                                        name="loc_4"
                                        value={formData.loc_4 || ''}
                                        onChange={handleInputChange}
                                        pattern="[0-9]{14}"
                                        maxLength={14}
                                        title="Le numéro SIRET doit contenir 14 chiffres"
                                        required
                                    />
                                </div>
                                <button
                                    type='button'
                                    onClick={() => handleSireneLookup(formData.loc_4)}
                                    className='save-button'
                                    title="Vérifier via l'API Sirene"
                                >
                                    Vérifier le SIRET
                                </button>
                            </div>
                        </>
                    )}

                    <div className="form-group">
                        <label htmlFor="loc_12_1">ETAGE / ESCALIER / APPARTEMENT:</label>
                        <input
                            type="text"
                            id="loc_12_1"
                            name="loc_12_1"
                            value={formData.loc_12_1 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_13_1">IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
                        <input
                            type="text"
                            id="loc_13_1"
                            name="loc_13_1"
                            value={formData.loc_13_1 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_14_1">N° DE LA VOIE:</label>
                        <input
                            type="text"
                            id="loc_14_1"
                            name="loc_14_1"
                            value={formData.loc_14_1 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]+"
                            title="Numéro de voie valide"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_15_1">EXTENSION (BIS, TER, ..):</label>
                        <input
                            type="text"
                            id="loc_15_1"
                            name="loc_15_1"
                            value={formData.loc_15_1 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_16_1">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                        <input
                            type="text"
                            id="loc_16_1"
                            name="loc_16_1"
                            value={formData.loc_16_1 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_17_1">LIBELLÉ DE VOIE:</label>
                        <input
                            type="text"
                            id="loc_17_1"
                            name="loc_17_1"
                            value={formData.loc_17_1 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_18_1">LIEU-DIT / BP / LOCALITÉ:</label>
                        <input
                            type="text"
                            id="loc_18_1"
                            name="loc_18_1"
                            value={formData.loc_18_1 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_19_1">CODE POSTAL:</label>
                        <input
                            type="text"
                            id="loc_19_1"
                            name="loc_19_1"
                            value={formData.loc_19_1 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]{5}"
                            title="Code postal à 5 chiffres"
                            maxLength={5}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_20_1">COMMUNE:</label>
                        <input
                            type="text"
                            id="loc_20_1"
                            name="loc_20_1"
                            value={formData.loc_20_1 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_21_1">TÉLÉPHONE PORTABLE:</label>
                        <input
                            type="tel"
                            id="loc_21_1"
                            name="loc_21_1"
                            value={formData.loc_21_1 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]{10}"
                            maxLength={10}
                            title="Numéro de téléphone à 10 chiffres"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_22_1">ADRESSE MAIL:</label>
                        <input
                            type="email"
                            id="loc_22_1"
                            name="loc_22_1"
                            value={formData.loc_22_1 || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            )}

            {(formData.loc_0 === '1' && (formData.loc_1 === '1' || formData.loc_1 === '2')) && (
                <div className="section">
                    <h3>LE LOCATAIRE</h3>
                    <div className="radio-group">
                        <label>VOUS ÊTES:</label>
                        <div className='radio-group-child'>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_5_physique"
                                    name="loc_5"
                                    value="0"
                                    checked={formData.loc_5 === '0'}
                                    onChange={() => handleRadioChange('loc_5', '0')}
                                    required
                                />
                                <label htmlFor="loc_5_physique">PERSONNE PHYSIQUE</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="loc_5_morale"
                                    name="loc_5"
                                    value="1"
                                    checked={formData.loc_5 === '1'}
                                    onChange={() => handleRadioChange('loc_5', '1')}
                                />
                                <label htmlFor="loc_5_morale">PERSONNE MORALE</label>
                            </div>
                        </div>
                    </div>

                    

                    {formData.loc_5 === '0' && (
                        <>
                         <div className="radio-group">
                                  <label>SEXE:</label>
                                  <div className="radio-group-child">
                                      <div>
                                          <input
                                              type="radio"
                                              id="occ_cotit_gender_homme"
                                              name="occ_cotit_gender"
                                              value="0"
                                              checked={formData.occ_cotit_gender === '0'}
                                              onChange={() => handleRadioChange('occ_cotit_gender', '0')}
                                              required
                                          />
                                          <label htmlFor="occ_cotit_gender_homme">HOMME</label>
                                      </div>
                                      <div>
                                          <input
                                              type="radio"
                                              id="occ_cotit_gender_femme"
                                              name="occ_cotit_gender"
                                              value="1"
                                              checked={formData.occ_cotit_gender === '1'}
                                              onChange={() => handleRadioChange('occ_cotit_gender', '1')}
                                          />
                                          <label htmlFor="occ_cotit_gender_femme">FEMME</label>
                                      </div>
                                  </div>
                              </div>
                            <div className="form-group">
                                <label htmlFor="loc_6">NOM ET PRÉNOM:</label>
                                <input
                                    type="text"
                                    id="loc_23"
                                    name="loc_23"
                                    value={formData.loc_23 || ''}
                                    onChange={handleInputChange}
                                    pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                    title="Veuillez entrer un nom et prénom valides (lettres, espaces, tirets et apostrophes uniquement)"
                                    maxLength="100"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="loc_24">NOM D&apos;USAGE (FACULTATIF):</label>
                                <input
                                    type="text"
                                    id="loc_24"
                                    name="loc_24"
                                    value={formData.loc_24 || ''}
                                    onChange={handleInputChange}
                                    pattern="^[A-Za-zÀ-ÖØ-öø-ÿ\s\-']+$"
                                    title="Veuillez entrer un nom valide (lettres, espaces, tirets et apostrophes uniquement)"
                                    maxLength="100"
                                />
                            </div>
                        </>
                    )}

                    {formData.loc_5 === '1' && (
                        <>
                            <div className="form-group">
                                <label htmlFor="loc_7">RAISON SOCIALE:</label>
                                <input
                                    type="text"
                                    id="loc_7"
                                    name="loc_7"
                                    value={formData.loc_7 || ''}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="form-group siret-group">
                                <div className='input-group'>
                                    <label htmlFor="loc_8">N° SIRET:</label>
                                    <input
                                        type="text"
                                        id="loc_8"
                                        name="loc_8"
                                        value={formData.loc_8 || ''}
                                        onChange={handleInputChange}
                                        pattern="[0-9]{14}"
                                        maxLength={14}
                                        title="Le numéro SIRET doit contenir 14 chiffres"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => handleSireneLookup(formData.loc_8)}
                                        className="save-button"
                                        title="Vérifier via l'API Sirene"
                                    >
                                        Vérifier
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="form-group">
                        <label htmlFor="loc_12_2">ETAGE / ESCALIER / APPARTEMENT:</label>
                        <input
                            type="text"
                            id="loc_12_2"
                            name="loc_12_2"
                            value={formData.loc_12_2 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_13_2">IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
                        <input
                            type="text"
                            id="loc_13_2"
                            name="loc_13_2"
                            value={formData.loc_13_2 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_14_2">N° DE LA VOIE:</label>
                        <input
                            type="text"
                            id="loc_14_2"
                            name="loc_14_2"
                            value={formData.loc_14_2 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]+"
                            title="Numéro de voie valide"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_15_2">EXTENSION (BIS, TER, ..):</label>
                        <input
                            type="text"
                            id="loc_15_2"
                            name="loc_15_2"
                            value={formData.loc_15_2 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_16_2">TYPE DE VOIE (RUE, AVENUE, ..):</label>
                        <input
                            type="text"
                            id="loc_16_2"
                            name="loc_16_2"
                            value={formData.loc_16_2 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_17_2">LIBELLÉ DE VOIE:</label>
                        <input
                            type="text"
                            id="loc_17_2"
                            name="loc_17_2"
                            value={formData.loc_17_2 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_18_2">LIEU-DIT / BP / LOCALITÉ:</label>
                        <input
                            type="text"
                            id="loc_18_2"
                            name="loc_18_2"
                            value={formData.loc_18_2 || ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_19_2">CODE POSTAL:</label>
                        <input
                            type="text"
                            id="loc_19_2"
                            name="loc_19_2"
                            value={formData.loc_19_2 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]{5}"
                            maxLength={5}
                            title="Code postal à 5 chiffres"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_20_2">COMMUNE:</label>
                        <input
                            type="text"
                            id="loc_20_2"
                            name="loc_20_2"
                            value={formData.loc_20_2 || ''}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_21_2">TÉLÉPHONE PORTABLE:</label>
                        <input
                            type="tel"
                            id="loc_21_2"
                            name="loc_21_2"
                            value={formData.loc_21_2 || ''}
                            onChange={handleInputChange}
                            pattern="[0-9]{10}"
                            maxLength={10}
                            title="Numéro de téléphone à 10 chiffres"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="loc_22_2">ADRESSE MAIL:</label>
                        <input
                            type="email"
                            id="loc_22_2"
                            name="loc_22_2"
                            value={formData.loc_22_2 || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            )}

            {modalData && (
            <div className="modal-overlay">
                <div className="modal-content modal-insee">
                <h3>Informations Entreprise</h3>

                <p><strong>Raison sociale :</strong> {modalData.etablissement?.uniteLegale?.denominationUniteLegale || "[Non renseignée]"}</p>
                <p><strong>Nom :</strong> {modalData.etablissement?.uniteLegale?.nomUniteLegale || "[Non renseigné]"}</p>
                <p><strong>Prénom :</strong> {modalData.etablissement?.uniteLegale?.prenom1UniteLegale || "[Non renseigné]"}</p>
                <p><strong>Adresse :</strong> {[
                    modalData.etablissement?.adresseEtablissement?.numeroVoieEtablissement,
                    modalData.etablissement?.adresseEtablissement?.typeVoieEtablissement,
                    modalData.etablissement?.adresseEtablissement?.libelleVoieEtablissement
                ].filter(Boolean).join(" ") || "[Non renseignée]"}</p>
                <p><strong>Code postal :</strong> {modalData.etablissement?.adresseEtablissement?.codePostalEtablissement || "[Non renseigné]"}</p>
                <p><strong>Commune :</strong> {modalData.etablissement?.adresseEtablissement?.libelleCommuneEtablissement || "[Non renseignée]"}</p>

                <button className="finish-button" onClick={() => setModalData(null)}>Fermer</button>
                </div>
            </div>
            )}

            {modalError && (
            <div className="error-message">
                {modalError} <button className="finish-button" onClick={() => setModalError(null)}>Fermer</button>
            </div>
            )}


            <div className="button-container">
                <button type="button" className="prev-button" onClick={handlePrevious}>Précédent</button>
                <button type="button" className="save-button" onClick={() => handleSave(formData)}>ENREGISTRER</button>
                <button type="button" className="next-button" onClick={handleSubmit}>Suivant</button>
            </div>
        </>
    );
};

StepThreeOccasion.propTypes = {
    sendData: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func,
    commonData: PropTypes.object,
    handleSave: PropTypes.func.isRequired,
};

export default StepThreeOccasion;